export { SimpleTraceViewer } from "./TraceViewer";
export type { TraceData, TraceSpan } from "./Trace";
